module.exports = __webpack_public_path__ + "static/img/user-bg.0e328f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/user-bg.png
// module id = b+yZ
// module chunks = 1